// extracted by mini-css-extract-plugin
export default {"fabricsWrapper":"jRdzv","fabricsPlaceholder":"HauJz","fabricsMore":"LkyLH"};